module.exports = __webpack_public_path__ + "static/media/mabit.b0f5cc40.png";